import React from 'react';
import useBuildContentstackImageSrc from '@drc/hooks/useBuildContentstackImageSrc';

import { Image } from '@stockx/ui';

const TILE_IMAGE_OPTIONS = {
  width: 234,
  height: 160,
};

const TileCollectionTileImage = ({ image }) => {
  const { imageSrc, imageSrcSet } = useBuildContentstackImageSrc({
    src: image?.url,
    options: TILE_IMAGE_OPTIONS,
  });

  return (
    <Image
      referrerPolicy="origin"
      srcSet={imageSrcSet}
      src={imageSrc}
      alt={image?.alt}
      data-testid="tile-collection-image"
      loading="lazy"
    />
  );
};

export default TileCollectionTileImage;
